import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError, lastValueFrom, Observable, take, tap, throwError } from 'rxjs';
import { UrlService } from '../../../shared/services/url/url.service';
import { HttpService, ResponseType } from '../../../shared/services/http/http.service';
import {
  RepairTrackingCounters,
  RepairTrackingHistory,
  RepairTrackingSearch,
} from '../interfaces/repair-tracking.interface';

@Injectable({
  providedIn: 'root',
})
export class LmrServices {
  constructor(
    private _urlService: UrlService,
    private _httpService: HttpService
  ) {}

  getDealers(filter: {}) {
    const url = this._urlService.getUrl('API_URL_DEALER.dealers');
    return this._httpService.get(url, filter).pipe(catchError((error: any) => throwError(error)));
  }

  newDealer(payload: {}) {
    const url = this._urlService.getUrl('API_URL_DEALER.dealers');
    return this._httpService.post(url, payload).pipe(catchError((error: any) => throwError(error)));
  }

  updateDealer(id: string, dealer: {}): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.updateDealer', { id });
    return this._httpService.patch(url, dealer).pipe(catchError((error: any) => throwError(error)));
  }

  listBid(filters: any) {
    const url = this._urlService.getUrl('API_URL_DEALER.listBid');
    return this._httpService.post(url, filters).pipe(catchError((error: any) => throwError(error)));
  }

  suppliersBid() {
    const url = this._urlService.getUrl('API_URL_DEALER.suppliersBid');
    return this._httpService.get(url, {}).pipe(catchError((error: any) => throwError(error)));
  }

  historySuppliers(params: {}) {
    const url = this._urlService.getUrl('API_URL_DEALER.historySuppliers');
    return this._httpService.get(url, params).pipe(catchError((error: any) => throwError(error)));
  }

  importSupplier(file: File, fornecedorId: string): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.importSupplier', { fornecedorId });
    const formData = new FormData();
    formData.append('Arquivo', file);
    return this._httpService
      .post(url, formData)
      .pipe(catchError((error: any) => throwError(error)));
  }

  importDefectSolution(file: File): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.importDefectSolution');
    const formData = new FormData();
    formData.append('Arquivo', file);
    return this._httpService
      .post(url, formData)
      .pipe(catchError((error: any) => throwError(error)));
  }

  downloadImportFile(supplierId: string): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.downloadImportFile', { supplierId });
    return this._httpService.get(url, null, ResponseType.ARRAYBUFFER);
  }

  exportDefectSolutionTemplate(): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.exportDefectSolution');
    return this._httpService.get(url, null, ResponseType.ARRAYBUFFER);
  }

  listDefectSolution(filter: {}): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.listDefectSolution');
    return this._httpService.get(url, filter).pipe(catchError((error: any) => throwError(error)));
  }

  exportTemplateImportBID(): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.exportTemplateImportBID');
    return this._httpService.get(url, null, ResponseType.ARRAYBUFFER);
  }

  listMatriz(params: { filtro?: string; page?: number; pageSize?: number }): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.listMatriz');
    return this._httpService
      .get(url, { ...params, filtro: params.filtro?.trim() })
      .pipe(catchError((error: any) => throwError(error)));
  }

  importMatriz(file: File): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.importMatriz');
    const formData = new FormData();
    formData.append('Arquivo', file);
    return this._httpService
      .post(url, formData)
      .pipe(catchError((error: any) => throwError(error)));
  }

  templateMatriz(): Observable<any> {
    const url = this._urlService.getUrl('API_URL_DEALER.templateMatriz');
    return this._httpService.get(url, null, ResponseType.ARRAYBUFFER);
  }

  exportDataTable(filters: any) {
    const url = this._urlService.getUrl('API_URL_DEALER.exportDataTable');
    return this._httpService.post(url, filters).pipe(catchError((error: any) => throwError(error)));
  }

  getRepairTrackingCounters(): Observable<RepairTrackingCounters> {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.repairTrackingCounters');
    return this._httpService.get(url, {}).pipe(catchError((error: any) => throwError(error)));
  }

  searchRepairTracking(term: string): Observable<RepairTrackingSearch> {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.repairTrackingSearch');
    return this._httpService
      .get(url, { term: term.trim() })
      .pipe(catchError((error: any) => throwError(error)));
  }

  getRepairTrackingDetails(tradeId: string): Observable<RepairTrackingHistory> {
    const url = this._urlService.getUrl('RECERTIFICATION_TVF.repairTrackingDetails', { tradeId });
    return this._httpService.get(url, {}).pipe(catchError((error: any) => throwError(error)));
  }

}
